import { createApp } from 'vue'
import useApplicationStore from "./use/applicationStore";
import Application from './components/Application/Application.vue'
import BuildingsPeopleFinder from './components/BuildingsPeopleFinder.vue'
import Favorite from './components/Favorite.vue'
import PropertyFinder from './components/PropertyFinder.vue'
import PropertyOptions from './components/PropertyOptions.vue'

const { store } = useApplicationStore()

if (document.getElementById('application')) {
  createApp(Application).use(store).mount('#application')
}

if (document.getElementById('buildings-people-finder')) {
  createApp(BuildingsPeopleFinder).mount('#buildings-people-finder')
}

if (document.getElementById('favorite')) {
  createApp(Favorite).use(store).mount('#favorite')
}

if (document.getElementById('property-finder')) {
  createApp(PropertyFinder).use(store).mount('#property-finder')
}

if (document.getElementById('property-options')) {
  createApp(PropertyOptions).mount('#property-options')
}
